import { BodyText, withStyles } from 'vopay';
import { useTranslation } from 'react-i18next';
import type { UserRoles } from 'vopay';
import ApproverCard from './ApproverCard';
import styleSheet from './Approvers.module.scss';

const cn = withStyles(styleSheet);

interface ApproversDetailsProps {
  approvers: Record<string, UserRoles[]>;
}

const ApproversDetails = ({ approvers }: ApproversDetailsProps) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Roles.Approvers.Details',
  });

  const approverUsernames = Object.keys(approvers);

  if (approverUsernames.length === 0) {
    return (
      <BodyText className={cn('emptyState')}>
        {t('noApproversMessage', { defaultValue: 'No approvers have been assigned.' })}
      </BodyText>
    );
  }

  return (
    <div className={cn('approversContainer')}>
      {approverUsernames.map((username) => (
        <ApproverCard key={username} username={username} paymentRails={approvers[username]} />
      ))}
    </div>
  );
};

export default ApproversDetails;
